<div *ngIf="guest?.primaryEmail">{{ $safeNavigationMigration(guest?.primaryEmail) | truncate : 25 }}</div>
<div *ngIf="guest?.phone">{{ guest?.phone }}</div>
<div [innerHTML]="$safeNavigationMigration(guest?.address) | address : true"></div>
